import { getProductParentId } from '../helpers/normalisers'

export function KlaviyoStarRating({ result }) {
  const productId = getProductParentId(result) || result?.id || result?.uid
  if (!productId) return null

  const productTitle = result.name || result.title || ''
  const productType = result.type || result.product_type || ''

  return (
    <klaviyo-star-rating
      key={productId}
      product-id={productId}
      product-title={productTitle}
      product-type={productType}
      disable-interaction=""
      className={String.raw`[&_.kl\_reviews\_\_full\_star]:!size-[14px] [&_.kl\_reviews\_\_partial\_star]:!size-[14px] [&_.kl\_reviews\_\_empty\_star]:!size-[14px] [&_.kl\_reviews\_\_star\_rating\_widget\_\_label]:!hidden`}
    >
      <div className="klaviyo-star-rating-container flex flex-nowrap items-center">
        <div
          className="klaviyo-star-rating-widget flex"
          slot="productReviews"
          data-id={productId}
          data-product-title={productTitle}
          data-product-type={productType}
        ></div>
      </div>
    </klaviyo-star-rating>
  )
}
